import { isSafeElearningMediaFilename } from "@monorepo/shared/learning";

import { CMS_MEDIA_BASE_URL } from "../../config";

export class LearningMediaReferenceError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "LearningMediaReferenceError";
  }
}

export const assertLearningMediaFilename = (filename: string): string => {
  if (!isSafeElearningMediaFilename(filename)) {
    throw new LearningMediaReferenceError("Invalid learning media filename");
  }
  return filename;
};

const configuredLearningMediaBaseUrl = (): string =>
  process.env.REACT_APP_LEARNING_MEDIA_BASE_URL || CMS_MEDIA_BASE_URL;

export const resolveLearningMediaUrl = (filename: string, baseUrl = configuredLearningMediaBaseUrl()): string => {
  assertLearningMediaFilename(filename);
  let parsedBase: URL;
  try {
    parsedBase = new URL(baseUrl);
  } catch {
    throw new LearningMediaReferenceError("Invalid learning media base URL");
  }
  if (parsedBase.protocol !== "http:" && parsedBase.protocol !== "https:") {
    throw new LearningMediaReferenceError("Unsupported learning media base URL");
  }
  const normalizedBase = parsedBase.toString().replace(/\/$/, "");
  return `${normalizedBase}/${filename}`;
};
